module.exports = __webpack_public_path__ + "img/colour-star.611c79c1.svg";